import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import TaskFormContainer from '../../../../containers/projects/TaskFormContainer.jsx';

const NewTask = ({ changeImpactId, projectId, slug }) => (
  <>
    <Helmet>
      <title>New Task | ChangeSync</title>
    </Helmet>
    <TaskFormContainer
      projectId={projectId}
      changeImpactId={changeImpactId}
      slug={slug}
    />
  </>
);

NewTask.getInitialProps = ({ query }) => ({
  changeImpactId: Number(query.changeImpactId),
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewTask));
